import {
    ICadastrarFormularios,
    IResponderPesquisaSatisfacao,
    IVincularTemplateFormulario,
} from "../../../Interfaces/Geral/Formularios/FormulariosInterface";
import {
    BaixarFormularioPDFService,
    DesvincularTemplateFormularioService,
    ListarFormulariosTemplatesService,
    VincularTemplateFormularioService,
} from "../../../Services/AssistenciaTecnica/Formularios/FormulariosServices";
import {
    CadastrarFormulariosService,
    AtualizarFormulariosService,
    GetFormulariosService,
    DeletarFormService,
    ListarFormulariosService,
    CadastrarPesquisaRespondidaService,
    ListarPesquisaRespondidaService,
    BuscarFormularioPeloNomeService,
    ListarFormulariosRespondidosServices,
    ListaPesquisaSatisfacaoRespostasFormularioHelpdeskService,
    GetTemplateFormularioService,
    CadastrarPesquisaSatisfacaoFormularioRespondidoService,
    GetTermoRecebimentoHTMLService,
    ListarFormulariosRespondidosPorCasoService,
    BuscarAgrupamentoFormularioService,
} from "../../../Services/Geral/Formularios/FormularioServices";

import { Controller } from "../../Controller";

export function CadastrarFormulariosController(
    requestBody: ICadastrarFormularios
) {
    return Controller(CadastrarFormulariosService(requestBody));
}
export function AtualizarFormulariosController(
    requestBody: ICadastrarFormularios
) {
    return Controller(AtualizarFormulariosService(requestBody));
}
export function GetFormulariosController(idformulario: number) {
    return Controller(GetFormulariosService(idformulario));
}

export function DeletarFormController(idFormulario: number) {
    return Controller(DeletarFormService(idFormulario));
}

export function ListarFormulariosController() {
    return Controller(ListarFormulariosService());
}

export function BaixarFormularioPDFController(
    idFormulario: number,
    idCaso: number,
    nrAgrupamento?: string
) {
    return Controller(
        BaixarFormularioPDFService(idFormulario, idCaso, nrAgrupamento)
    );
}

export function CadastrarPesquisaRespondidaController(
    idCaso: number,
    requestBody: IResponderPesquisaSatisfacao
) {
    return Controller(CadastrarPesquisaRespondidaService(idCaso, requestBody));
}

export function ListarPesquisaRespondidaController(
    idFormulario: number,
    nrAgrupamento?: string
) {
    return Controller(
        ListarPesquisaRespondidaService(idFormulario, nrAgrupamento)
    );
}

export function BuscarFormularioPeloNomeController(
    cdEtapa: string,
    tpPesquisa?: "AssistenciaTec" | "Vistoria"
) {
    return Controller(BuscarFormularioPeloNomeService(cdEtapa, tpPesquisa));
}

export function BuscarAgrupamentoFormularioController(
    idFormulario: number,
    idCaso: number
) {
    return Controller(BuscarAgrupamentoFormularioService(idFormulario, idCaso));
}

export function ListarFormulariosTemplatesDesvinculadosController(
    idModulo: number
) {
    return Controller(ListarFormulariosTemplatesService(false, idModulo));
}

export function ListarFormulariosTemplatesVinculadosController(
    idModulo: number
) {
    return Controller(ListarFormulariosTemplatesService(true, idModulo));
}

export function VincularTemplateFormularioController(
    requestBody: IVincularTemplateFormulario
) {
    return Controller(VincularTemplateFormularioService(requestBody));
}

export function DesvincularTemplateFormularioController(
    idDocumentoTemplateModulo: number,
    idFormulario: number
) {
    return Controller(
        DesvincularTemplateFormularioService(
            idDocumentoTemplateModulo,
            idFormulario
        )
    );
}

export function ListarFormulariosRespondidosController(idConta: number) {
    return Controller(ListarFormulariosRespondidosServices(idConta));
}

export function ListaPesquisaSatisfacaoRespostasFormularioHelpdeskController(
    idContaChat: number,
    idCaso: number
) {
    return Controller(
        ListaPesquisaSatisfacaoRespostasFormularioHelpdeskService(
            idContaChat,
            idCaso
        )
    );
}

export function GetTemplateFormularioController(
    idFormulario?: number,
    idTipoCaso?: number,
    idCaso?: number
) {
    return Controller(
        GetTemplateFormularioService(idFormulario, idTipoCaso, idCaso)
    );
}

export function CadastrarPesquisaSatisfacaoFormularioRespondidoController(
    idCaso: number,
    requestBody: IResponderPesquisaSatisfacao
) {
    return Controller(
        CadastrarPesquisaSatisfacaoFormularioRespondidoService(
            idCaso,
            requestBody
        )
    );
}

export function GetTermoRecebimentoHTMLController(
    idFormulario?: number,
    idTipoCaso?: number,
    idCaso?: number,
    cdEtapa?: string,
    flExportar?: boolean
) {
    return Controller(
        GetTermoRecebimentoHTMLService(
            idFormulario,
            idTipoCaso,
            idCaso,
            cdEtapa,
            flExportar
        )
    );
}

export function ListarFormulariosRespondidosPorCasoController(idCaso: number) {
    return Controller(ListarFormulariosRespondidosPorCasoService(idCaso));
}
